import React from 'react'
import { List } from '@shopify/polaris';
import { setAlt, setSrc, toggleModal } from '../../store/actions/guideActions';

export const saveProducts = async (data, fetchJson) => {
    if (window.navigator.onLine) {
        if (!fetchJson) {
            console.log("fetchJson is required to save products.")
            return
        }
        try {
            const response = await fetchJson(`/settings/free_products`, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data)
            })
            if (response?.status >= 500) {
                console.log("Something went wrong! Please try later.")
                return
            }
            return response
        } catch (error) {
            console.log(error)
        }
    } else {
        console.log('Data can not be saved, Check Your Internet Connection!');
    }
}
export const saveProductOption = async (data, fetchJson) => {
    if (window.navigator.onLine) {
        if (!fetchJson) {
            console.log("fetchJson is required to save product option.")
            return
        }
        try {
            const response = await fetchJson(`/settings/product_option`, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data)
            })
            if (response?.status >= 500) {
                console.log("Something went wrong! Please try later.")
                return
            }
            return response
        } catch (error) {
            console.log(error)
        }
    } else {
        console.log('Data can not be saved, Check Your Internet Connection!');
    }
}

export const setTime = (shopId, fetchJson) => {
    if (window.navigator.onLine) {
        const date = new Date().toLocaleString()
        if (!fetchJson) {
            console.log("fetchJson is required to set time.")
            return
        }
        fetchJson(`/settings/time`, {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ date, shopId })
        }).catch(error => {
            console.log(error.message)
        })
    } else {
        console.log({ "error": 'Check your connection.' })
    }
}

export const showList = (listItems, type = "bullet") => {
    const items = listItems.map((item, i) => {
        return <List.Item key={i}><span style={{ "color": 'black' }}>{item}</span></List.Item>
    })
    return <List type={type}>
        {items}
    </List>
}

export const zoomInImage = (dispatch, src) => {
    dispatch(toggleModal(true))
    dispatch(setSrc(src))
    dispatch(setAlt(""))
}

export const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);
export const normalize = val => val.toLowerCase().replace(/\s+/g, "")
